import { render, staticRenderFns } from "./ChiefScientistOpinion.vue?vue&type=template&id=1c0e129b&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ChiefScientistOpinion.vue?vue&type=script&lang=js&"
export * from "./ChiefScientistOpinion.vue?vue&type=script&lang=js&"
import style0 from "./ChiefScientistOpinion.vue?vue&type=style&index=0&id=1c0e129b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e129b",
  null
  
)

export default component.exports